import React, { useEffect, useState } from "react";
import { api, API } from "@/lib/api";
import { Download as DownloadIcon, FileText, Folder } from "lucide-react";

export default function DownloadsPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/downloads").then(({ data }) => { setItems(data); setLoading(false); }).catch(() => setLoading(false));
  }, []);

  const grouped = items.reduce((acc, it) => {
    const cat = it.category || "Allgemein";
    (acc[cat] = acc[cat] || []).push(it);
    return acc;
  }, {});

  return (
    <div className="pt-32 pb-24 min-h-screen bg-slate-50" data-testid="downloads-page">
      <div className="mbw-container max-w-4xl">
        <div className="mbw-overline mb-4">Downloads</div>
        <h1 className="font-heading text-5xl md:text-6xl font-bold tracking-tighter text-[#1A2433] leading-[1.02] mb-4">
          Formulare & <span className="text-[#991B1B]">Merkblätter.</span>
        </h1>
        <p className="text-lg text-slate-600 mb-12">
          Alles, was Sie für die Zusammenarbeit mit uns oder zur eigenen Information benötigen.
        </p>

        {loading ? (
          <div className="text-slate-500">Lade…</div>
        ) : items.length === 0 ? (
          <div className="bg-white rounded-2xl p-12 border border-slate-200 text-center">
            <Folder className="w-12 h-12 text-slate-300 mx-auto mb-4" />
            <p className="text-slate-600">Aktuell sind keine Downloads verfügbar.</p>
          </div>
        ) : (
          <div className="space-y-10">
            {Object.entries(grouped).map(([cat, list]) => (
              <div key={cat}>
                <h2 className="font-heading text-2xl font-bold text-[#1A2433] mb-4">{cat}</h2>
                <div className="grid sm:grid-cols-2 gap-3">
                  {list.map((d) => (
                    <a
                      key={d.id}
                      href={`${API}/downloads/${d.id}/file`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="mbw-card p-5 group flex items-start gap-4"
                      data-testid={`download-public-${d.id}`}
                    >
                      <div className="w-11 h-11 rounded-lg bg-[#1A2433] flex items-center justify-center flex-shrink-0">
                        <FileText className="w-5 h-5 text-[#DC2626]" />
                      </div>
                      <div className="flex-1 min-w-0">
                        <div className="font-semibold text-[#1A2433] mb-1 group-hover:text-[#991B1B] transition-colors">{d.title}</div>
                        {d.description && <div className="text-sm text-slate-600 mb-2 line-clamp-2">{d.description}</div>}
                        <div className="text-xs text-slate-500">{d.filename} · {(d.size_bytes / 1024).toFixed(0)} KB</div>
                      </div>
                      <DownloadIcon className="w-4 h-4 text-slate-400 group-hover:text-[#991B1B] flex-shrink-0" />
                    </a>
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
